import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { DepotDashboardDetails } from "pages/depot-dashboard/DepotDashboardDetails";
import { Dashboard } from "../dashboard";
import { fetchDepotDetails } from "utils/api";
import { updateStatusSuccess } from "store/utils/actions";
import { useDispatch, useSelector } from "react-redux";
import { LoginSelector } from "store/auth/login/selectors";
import { UtilsSelector } from "store/utils/selectors";
import { Spin } from "antd";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    width: "100%",
    height: "100vh",
    maxHeight: "100vh",
  },
});

export const DepotDashboard = () => {
  const classes = useStyles();
  const { user } = useSelector(LoginSelector);
  const [showDashboard, setShowDashboard] = useState(false);
  const { hasFeatureDOC } = useSelector(UtilsSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDepotDetails({ name: user?.depotName })
      .then(async ({ data }) => {
        dispatch(updateStatusSuccess(data?.result?.operationalStatus));
        setShowDashboard(true);
      })
      .catch(() => {
        setShowDashboard(true);
      });
  }, []);

  return (
    <div className="page-content">
      {showDashboard ? (
        <>
          {hasFeatureDOC ? (
            <Container fluid>
              <DepotDashboardDetails />
            </Container>
          ) : (
            <Dashboard />
          )}
        </>
      ) : (
        <Spin spinning size="large">
          <div className={classes.root}></div>
        </Spin>
      )}
    </div>
  );
};
